<template>
  <div :class="s.contentIntroduce">
    <img :src="require('../../images/ic_logo.png')" />
    <p>广东智选保险代理有限公司（简称“智选保代”）成立于2007年，2023年1月迁址广东，是经银保监批准成立的具有全国性互联网销售资质的保险中介机构，自营的智选保险管理系统已获得信息系统安全保护第三级认证。</p>
    <p>
      智选保代是小鹏汽车生态合作企业，是小鹏汽车实现用户和生态圈串联保险服务的纽带，智选保代依托小鹏汽车业务资源，积极探索智能保险服务的高质量发展，以智能汽车、智能网联生态圈为主要的保险服务场景，专注于中国领先的智能汽车、智能网联生态领域的深耕。致力于通过“在线化、数字化、智能化”的创新保险服务模式与线下保险服务有机融合，高效衔接客户保险服务全流程，并协助车企和保险行业有效降低保险业务综合运营成本，提升保险业务各个流程和关键节点的处理效率。
    </p>
    <br />
    <br />
    <img :src="require('../../images/ic_info1.jpg')"/>
    <br />
    <img :src="require('../../images/ic_info2.jpg')"/>
    <p>2023年4月14日，智选保代开业揭幕暨合作签约仪式在小鹏汽车智能产业园区成功举办，小鹏汽车副董事长 联席总裁、广东智选保险代理有限公司负责人、市、区金融监管部门领导以及相关保司领导出席活动。 </p>
    <p>智选保代与中国人民财产保险、中国太平洋财产保险、中国平安财产保险、中国人寿财产保险、阳光财产保险5家保司的省级分支机构签署合作协议，共同致力于探索与落地保险科技在智能汽车的应用，拓展和创新智能车险服务用户的新模式。</p>
  </div>
</template>

<script>
export default {
  name: 'ContentIntroduce',
  computed: {
    s() {
      return this.$style;
    }
  }
};
</script>

<style scoped lang="less" module>
.contentIntroduce {
  font-size: 15px;
  line-height: 30px;
  text-indent: 2em;

  img {
    max-width: 70%;
    object-fit: cover;
  }
}
</style>
